import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { LicenseStatus } from '../../models/SubscriptionDTO';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { SepBarChartComponent } from '../../../../../shared/components/sep-bar-chart/sep-bar-chart.component';
import { LicenseCalculationsService } from '../../services/license-calculations.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { TextButtonComponent } from '../../../../../shared/components/text-button/text-button.component';
import { Store } from '@ngxs/store';
import { CurrentUserState } from '../../../../../core/store/current-user/current-user.state';
import { Subscription } from '../../../../../core/store/current-user/models/CurrentUserUIModel';

@Component({
  selector: 'app-license-overview-card',
  imports: [
    MatIconModule,
    AsyncPipe,
    SepBarChartComponent,
    MatTooltipModule,
    TranslocoModule,
    TextButtonComponent,
  ],
  templateUrl: './license-overview-card.component.html',
})
export class LicenseOverviewCardComponent implements OnInit, OnDestroy {
  @Output() addLicensesButtonClickEvent: EventEmitter<void> =
    new EventEmitter<void>();
  private readonly licenseCalculationsService = inject(
    LicenseCalculationsService,
  );
  private readonly store = inject(Store);

  licenses$: Observable<Array<{ id: string; status: LicenseStatus }>>;
  assignedLicensesCount$: Observable<number>;
  reservedLicensesCount$: Observable<number>;
  availableLicensesCount$: Observable<number>;
  totalLicensesCount$: Observable<number>;
  availableToTotalLicensesRatio$: Observable<number>;
  subscription$: Observable<Subscription | null> = this.store.select(
    CurrentUserState.subscription,
  );
  freeTrial = false;
  private readonly destroy$: Subject<void> = new Subject();

  ngOnInit(): void {
    this.assignedLicensesCount$ =
      this.licenseCalculationsService.getAssignedLicensesCount();
    this.reservedLicensesCount$ =
      this.licenseCalculationsService.getReservedLicensesCount();
    this.availableLicensesCount$ =
      this.licenseCalculationsService.getAvailableLicensesCount();
    this.totalLicensesCount$ =
      this.licenseCalculationsService.getTotalLicensesCount();
    this.availableToTotalLicensesRatio$ =
      this.licenseCalculationsService.getAvailableToTotalLicensesRatio();

    this.subscription$
      .pipe(takeUntil(this.destroy$))
      .subscribe((subscription) => {
        if (subscription?.freeTrialing) {
          this.freeTrial = true;
        } else {
          this.freeTrial = false;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
